<template>
  <div>
    <loader :is-visible="isLoading"></loader>
    <div class="container">
      <div class="container-post">
        <h1>DPD</h1>
        <div class="search grid-input">
          <!-- <div class="search__heading">
            <img src="../assets/images/icon/iconmonstr-magnifier-4.svg" alt="">
            <div class="wrapper">
              <div class="input-data search--input">
                <input type="text" required>
                <div class="underline"></div>
                <label>Search</label>
              </div>
            </div>
          </div> -->
          <select class="select-css" v-model="dpw_id" @change="getListData('reset')">
            <option value="" selected>Select DPW :</option>
            <option v-for="(data, index) in listDpw" :key="index" :value="data.dpw_id">{{ data.dpw_name }}</option>
          </select>
          <div class="button-right">
            <!-- <button class="btn-add mg-right" @click="view = 'formPageCategory'">
              Add Category
            </button> -->
            <button class="btn-add" @click="viewForm()">
              Add New
            </button>
          </div>
        </div>

        <div class="section-list">
          <ul class="main-post">
            <li class="list-post list--post btm-margin">
              <p>Title</p>
              <p>Address</p>
              <p>Author</p>
            </li>
            <div class="list-post__item">
              <li class="list-post list--post" v-for="(data,index) in listData" :key="index">
                <div class="list-post__title">
                  <p>{{ data.dpd_name }}</p>
                  <button class="button" @click="viewForm(data)" >Edit</button>
                  <button class="button hov-del" @click="delData(data.dpd_id)">Delete</button>
                </div>
                <p class="main-post__date">{{ data.dpd_alamat }}</p>
                <div> 
                  <p class="main-post__author">Admin</p>
                  <p class="main-post__email">Admin@gmail.com</p>
                </div>
              </li>
            </div>
          </ul>
          <paginate
            v-model="pageNum"
            :page-range="3"
            :page-count="totalPages"
            :margin-pages="2"
            :click-handler="getListData"
            :prev-text="'Prev'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'">
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment';
import alert from './../commons/alert.helper';
import Loader from './../components/Loader.vue';

import auth from '@/service/auth.js'

export default {
  name: 'DPD',
  data () {
    return {
      // view: 'listPage',
      dpw_id: '',
      listData: [],
      listDpw: [],
      isLoading: false,
      pageNum: 1,
      totalPages: 0,
      limit: 10,
      limitDpw: 1000,
    }
  },
  methods: {
    formatDate (val) {
      let date = val.split('T')[0]
      let time = val.split('T')[1].split('Z')[0]
      let dateTime = `${date} ${time}` 
      return moment(dateTime, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY HH:mm:ss')
    },
    viewForm (data) {
      const dataById = JSON.stringify(data)
      localStorage.setItem('dataPerindoById', dataById )
      this.$router.push(`/dpd-form/${data ? data.dpd_id:0}`)
    },
    async getListData (page) {
      this.isLoading = true

      if ( page === 'reset' ) {
          this.pageNum = 1
          page = 1
      }

      try {
        const response = await axios.get('/member/listdpd', {
          params: {
            dpw_id : this.dpw_id,
            page: page,
            limit: this.limit
          }
        })
        console.log('data DPD' , response)

        this.listData = response.data.data
        

        this.totalPages = Math.ceil(response.data.meta.total_data / this.limit)
        this.isLoading = false

          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async getListDpw() {
      this.isLoading = true
      try {
          const response = await axios.get('/member/listdpw', {
            params: {
              limit: this.limitDpw
            }
          })
          
          this.listDpw = response.data.data
          console.log('dataDpw', this.listDpw)
          this.isLoading = false
          
      } catch (error) {
        console.log(error)
        this.isLoading = false
      }
    },
    async delData(id) {
      let self = this
      alert.confirmation( async function () {
      self.isLoading = true
        try {
            const response = await axios.delete(`/member/dpd/${id}`)
            self.isLoading = false
            console.log(response)
            alert.success('Delete data success', () => self.getListData('reset'))
        } catch (error) {
            self.isLoading = false
            console.log(error)
            alert.failed('Delete data failed')
        }
      }, 'Are you sure to delete it?')
    },
  },
  components: {
      Loader
  },
  async created() {
    const res = await auth.checkAuth(this.$route.fullPath)
    if (res == false) {
      localStorage.clear()
      this.$router.push('/login')  
    }
    this.getListData('reset');
    this.getListDpw();
  },
  // watch: {
  //     pageNum() {
  //         this.pageNum = 1
  //     },
  // }
}
</script>